<script>
  import { onMount } from "svelte";
  import Header from "../../views/Header.svelte";

  let visible = false;

  onMount(() => {
    setTimeout(() => {
      visible = true;
    }, 50);
  });
</script>

<style lang="scss">
  .headline {
    display: flex;
    flex-direction: column;
    padding: 0 15em;
    opacity: 1;
    background: transparent url('../assets/product-headline-bg.png') 0% 0% no-repeat padding-box;
    background-size: contain;
    height: 50em;

    visibility: hidden;
    opacity: 0;

    &.visible {
      transition: opacity 0.1s;
      visibility: visible;
      opacity: 1;
    }
    .headline__article {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      margin-top: 5em;

      .headline__text {
        h3 {
          margin: 0 2em 0;
        }

        p {
          color: var(--font-color-alternative);
          font-weight: bold;
          font-size: 22px;
          letter-spacing: 0;
          line-height: 30px;
          width: 43.7em;
          text-align: center;
          margin-top: 8em;
        }
      }
    }
  }
</style>

<section class="headline" class:visible={visible}>
  <Header />
  <article class="headline__article">
    <section class="headline__text">
      <h3 class="header-title wc">Optimise your<br/>energy use with<br/>Voltaware</h3>
    </section>
  </article>
</section>
